// @flow
import { combineReducers } from 'redux';
import authReducer from './auth';
import userReducer from './user';
import bannersReducer from './banners';
import resourcesReducer from './resources';
import singleResourceReducer from './resource';
import { filesReducer, getFileThumbReducer } from './files';
import requestsReducer from './requests';
import {
  shareReducer,
  sharedResourcesReducer,
  singleSharedResourceReducer,
  getSharedFileReducer,
  getSharedThumbReducer,
  viewSharedFileReducer,
  getToken,
  getAccessToken } from './shared';
import { providerStatusReducer, providerStatusesReducer } from './status';
import institutionsReducer from './institutions';
import locationReducer from './location';
import initialStore from '../initialStore';

const appReducer = combineReducers({
  auth: authReducer, // session info
  user: userReducer, // db info
  banners: bannersReducer,
  resources: resourcesReducer,
  resource: singleResourceReducer,
  fileThumb: getFileThumbReducer,
  files: filesReducer,
  requests: requestsReducer,
  institutions: institutionsReducer,
  location: locationReducer,
  status: providerStatusReducer,
  allStatuses: providerStatusesReducer,
  // shared resources
  shared: shareReducer,
  sharedResources: sharedResourcesReducer,
  sharedResource: singleSharedResourceReducer,
  sharedFileThumb: getSharedThumbReducer,
  sharedFileView: viewSharedFileReducer,
  sharedFileInfo: getSharedFileReducer,
  sharedToken: getToken,
  sharedAccessToken: getAccessToken
});

const rootReducer = (state, action) => {
  let newState = state;
  if (action.type === 'LOGOUT') {
    newState = initialStore;
  }
  return appReducer(newState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js